import { useStaticQuery, graphql } from 'gatsby'

export const useGraphqlDataHook = () =>
    useStaticQuery(graphql`
        {
            facebook: allFile(
                filter: {
                    relativePath: {
                        eq: "page/generic/community/static/image/fb.jpg"
                    }
                }
            ) {
                edges {
                    node {
                        childImageSharp {
                            fluid(
                                maxWidth: 560
                                srcSetBreakpoints: [560]
                                toFormat: NO_CHANGE
                                quality: 90
                            ) {
                                ...GatsbyImageSharpFluid_withWebp
                            }
                        }
                    }
                }
            }
            instagram: allFile(
                sort: { order: ASC, fields: [name] }
                filter: {
                    relativePath: {
                        regex: "page/generic/community/static/image/instagram/"
                    }
                }
            ) {
                edges {
                    node {
                        childImageSharp {
                            fluid(
                                maxWidth: 476
                                srcSetBreakpoints: [476]
                                toFormat: NO_CHANGE
                                quality: 90
                            ) {
                                originalName
                                ...GatsbyImageSharpFluid_withWebp
                            }
                        }
                    }
                }
            }
            instagramLocalized: allFile(
                filter: {
                    relativePath: {
                        regex: "page/generic/community/static/image/localized/"
                    }
                }
            ) {
                edges {
                    node {
                        childImageSharp {
                            fluid(
                                maxWidth: 476
                                srcSetBreakpoints: [476]
                                toFormat: NO_CHANGE
                                quality: 90
                            ) {
                                originalName
                                ...GatsbyImageSharpFluid_withWebp
                            }
                        }
                    }
                }
            }
        }
    `)
